"use client";

import { useState } from "react";
import Image from "next/image";
import { FallbackImage } from "../common";
import { Industry } from "@/@types";
import Link from "next/link";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { ROUTES } from "@/config/routes";
import infoSvg from "../../../public/info.svg";
import Modal from "../common/Modal";

type IndustrySliderDetaildProps = {
  industry: Industry;
};

export const IndustrySliderDetail = ({
  industry,
}: IndustrySliderDetaildProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div
      className="
      relative 
      container 
      w-full
      max-w-[1744px]
      bg-dark03 
      text-white 
      px-8 
      pt-6 
      pb-10 
      -top-14
      lg:rounded-[2px]   
      lg:w-[87%] 
      "
    >
      {/* Sección de arriba: Imagen y Texto */}
      <div className="flex gap-8">
        {/* Versión laptp y escritorio */}
        <div className="flex items-center justify-center md:2/3 lg:1/3">
          <div>
            <FallbackImage
              src={industry.image_description}
              alt="Imagen del slider"
              className="object-contain"
              width={400}
              height={200}
            />
          </div>
        </div>

        {/* Columna del texto: 100% en móvil e iPad, 2/3 en laptop */}
        <div className="hidden w-full py-4 md:w-2/3 md:flex md:flex-col md:justify-center">
          <h1 className="text-4xl font-bold mb-4 uppercase">
            {industry.title}
          </h1>
          <div
            dangerouslySetInnerHTML={{ __html: industry.description || "" }}
          />
        </div>
      </div>

      {/* Versión movil */}
      <div className="md:hidden flex flex-row items-center gap-2">
        <h2 className="text-4xl font-bold uppercase mt-4">{industry.title}</h2>
        <Image
          src={infoSvg}
          alt="Imagen del slider"
          width={24}
          height={24}
          onClick={() => openModal()}
        />
      </div>

      {/* Botón de llamada a la acción */}
      <div className="absolute bottom-0 translate-y-1/2 w-full left-1/2 -translate-x-1/2 lg:left-auto lg:right-20 lg:translate-x-0 lg:min-w-[550px] lg:max-w-[550px] px-0 lg:px-4">
        <Link href={ROUTES.usedEquipments.details(industry.slug)}>
          <button className="bg-yellow-500 text-black font-bold py-3 px-6 hover:bg-yellow-600 flex items-center justify-center gap-2 w-full lg:w-auto lg:min-w-[550px] lg:max-w-[550px] uppercase">
            Conoce nuestro equipo usado aquí
            <ChevronRightIcon className="h-5 w-5" />
          </button>
        </Link>
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal} title={industry.title}>
        <div className="rounded w-[90%] md:w-[650px]">


          {/* Video de YouTube embebido */}
          <div
            className="w-full h-auto  overflow-y-auto"
            dangerouslySetInnerHTML={{ __html: industry.description || "" }}
          />

          {/* Botón para cerrar el modal */}
          <div className="mt-4 text-right">
            <button
              onClick={closeModal}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
            >
              Cerrar
            </button>
          </div>
        </div>

      </Modal>
      {/*
      <ModalDescription
        isOpen={isModalOpen}
        onClose={closeModal}
        title={industry.title}
        description={industry.description}
      />
    */}
    </div>
  );
};
